import { render } from "./NotificationBar.vue?vue&type=template&id=20dbc528&ts=true"
import script from "./NotificationBar.vue?vue&type=script&lang=ts"
export * from "./NotificationBar.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/NotificationBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20dbc528"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20dbc528', __exports__)) {
    api.reload('20dbc528', __exports__)
  }
  
  module.hot.accept("./NotificationBar.vue?vue&type=template&id=20dbc528&ts=true", () => {
    api.rerender('20dbc528', render)
  })

}


export default __exports__